import { LogLevel } from '@azure/msal-browser';


export const msalConfig = {
    auth: {
        clientId: String(process.env.REACT_APP_CLIENT_ID), 
        authority: 'https://login.microsoftonline.com/05d75c05-fa1a-42e7-9cf1-eb416c396f2d', 
        redirectUri: '/', 
        postLogoutRedirectUri: '/', 
        navigateToLoginRequestUrl: true, 
    },
    cache: {
        cacheLocation: 'sessionStorage', 
        storeAuthStateInCookie: false, 
    },
    system: {
        loggerOptions: {
            loggerCallback: (level: any, message: any, containsPii: any) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        console.info(message);
                        return;
                    case LogLevel.Verbose:
                        console.debug(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                    default:
                        return;
                }
            },
            logLevel: LogLevel.Verbose,
        },
    },
};
 export const protectedResources = {
    sherlock : {
        baseurl : process.env.REACT_APP_API_BASE_URL,
        scopes:{
            read: [String(process.env.REACT_APP_SCOPE_ID)],
        },
        
    }
 }

export const loginRequest = {
    scopes: ["User.Read"],
};

